<template>
    <div v-if="mounted" class="instagram">
        <div class="instagram__title text_13">
            <!-- <span>@p.p.s.brand</span> -->
            <span>#werethinkanorm</span>
            <!-- <span>#agenderagent</span> -->
        </div>
        <div class="instagram__content">
            <div class="instagram-list">
                <swiper :options="sliderOptions">
                    <swiper-slide v-for="(post, index) in slides" :key="index">
                        <div class="instagram-list__item" :class="`instagram-list__item--${post.type}`">
                            <span>
                                <UiImage
                                    v-if="post.image"
                                    :path="post.image"
                                    :desktop="{ width: 320 }"
                                    :alt="post.caption"
                                    :lazy="false">
                                </UiImage>
                            </span>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { Swiper, SwiperSlide } from "@/plugins/swiper.client";
import UiImage from "@/components/ui/Image";
export default {
    name: "Instagram",
    components: { Swiper, SwiperSlide, UiImage },
    data() {
        return {
            mounted: false,
            slides: [],
            sliderOptions: {
                slidesPerView: 2,
                loop: true,
                noSwiping: true,
                allowTouchMove: false,
                speed: 12000,
                autoplay: {
                    enabled: true,
                    delay: 1,
                    pauseOnMouseEnter: false,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    750: {
                        slidesPerView: 5,
                        speed: 5000,
                    },
                },
            },
        };
    },
    computed: {
        ...mapState({
            instaSlides: "globalvars/instaSlides",
        }),
    },
    async mounted() {
        try {
            const slides = await this.$axios.$get("/api/instagram-slider");
            for (const key in slides) {
                const element = slides[key];
                this.slides.push(element);
            }
            this.mounted = true;
        } catch (error) {
            console.log(`error instagram-slider =>`, error);
        }
    },
};
</script>
<style lang="less">
.instagram {
    margin-bottom: 64px;
    @media @sm {
        margin-bottom: 40px;
    }
    &__title {
        padding: 64px 32px;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        @media @sm {
            padding: 64px 16px;
        }

        span {
            display: inline-block;
            &:first-child:before {
                content: "/";
                margin-right: 12px;
            }
            &::after {
                content: "/";
                margin-left: 12px;
            }
        }
    }
}
.instagram-list {
    .swiper-container:not(.swiper-container-initialized) {
        .swiper-wrapper {
            display: flex;
            overflow: hidden;
            .swiper-slide {
                width: 20%;
                flex-shrink: 0;
            }
        }
    }
    &__item {
        width: 100%;
        padding-top: 100%;
        position: relative;
        display: block;
        a {
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            height: 100%;
            display: block;
            position: absolute;
        }
        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            -webkit-user-drag: none;
            user-select: none;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
        }
        &--video {
            a::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                border: 25px transparent solid;
                border-left-color: #fff;
                border-left-width: 35px;
                opacity: 0.5;
                z-index: 1;
                margin-top: -25px;
                margin-left: -15px;
            }
        }
    }
}

.swiper-wrapper {
    transition-timing-function: linear;
}
</style>
